"use client";

import { useSearchParams, useRouter } from "next/navigation";
import { Suspense, useEffect, useState } from "react";
import { Button, Card, CardContent, CardHeader, CardTitle } from "@eg/ui";
import { useTranslations } from "@/lib/i18n/I18nProvider";

function AgeGateInner() {
  const params = useSearchParams();
  const router = useRouter();
  const [accepted, setAccepted] = useState(false);
  const t = useTranslations();

  const returnTo = params.get("returnTo") || "/";

  function accept() {
    // 1 year
    document.cookie = `eg_age_confirmed=true; Max-Age=${60 * 60 * 24 * 365}; Path=/; SameSite=Lax`;
    setAccepted(true);
    // Use full redirect to support arbitrary returnTo
    window.location.href = returnTo;
  }

  useEffect(() => {
    // If already accepted, go back immediately
    if (document.cookie.includes("eg_age_confirmed=true")) {
      window.location.href = returnTo;
    }
  }, [returnTo, router]);

  return (
    <main className="mx-auto max-w-lg p-6">
      <Card>
        <CardHeader>
          <CardTitle>{t("ageGate.title")}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-gray-700">{t("ageGate.copy")}</p>
          <Button className="w-full" onClick={accept} disabled={accepted}>
            {t("ageGate.accept")}
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}

export default function AgeGatePage() {
  return (
    <Suspense fallback={null}>
      <AgeGateInner />
    </Suspense>
  );
}
